<template>
  <div class="container breadcrumbs">
    <a @click="$router.back()" class="breadcrumbs__back-button">&lsaquo; Назад</a>
    <ul class="nav align-self-center">
      <li
        v-for="(breadcrumb, idx) in breadcrumbs"
        :key="idx"
        @click="routeTo(idx)"
        :class="{'linked': !!breadcrumb.link}">

        {{ breadcrumb.name }}

        </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Breadcrumbs",
  computed: {
    breadcrumbs() {
      return this.$route.meta.breadcrumbs;
    }
  },
  methods: {
    routeTo(route) {
      if (this.breadcrumbs[route].link) {
        this.$router.push(this.breadcrumbs[route].link);
      }
    },
  }
};
</script>
<style lang="scss" scoped>
.breadcrumbs {
  display: flex;
  padding-top: 30px;
  padding-bottom: 30px;
  font-size: 13px;
  line-height: 15px;
  font-weight: 300;
}

.breadcrumbs__back-button {
  color: #000;
  margin-right: 20px;
  border: 1px solid #C7C7C7;
  border-radius: 5px;
  padding: 3px 10px;
  cursor: pointer;

  @include media-breakpoint-down(sm) {
    display: none;
  }
}

.linked {
  color: #6D9AE8;
  cursor: pointer;
}

.nav li+li:before {
  padding: 8px;
  color: black;
  content: "\003e";
}
</style>
